import React, { memo } from 'react';

interface DetailPageNumberSelectorProps {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  itemsPerRow?: number;
}

const NumberButton: React.FC<{
  num: number;
  selected: boolean;
  disabled: boolean;
  onClick: () => void;
}> = ({ num, selected, disabled, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`
      w-[72px] h-16 rounded-2xl text-[28px] font-medium transition-all
      ${selected
        ? 'bg-white/30 text-white border border-white/35'
        : 'bg-white/[0.08] text-white/80 border border-white/[0.12] hover:bg-white/14 hover:border-white/22'
      }
    `}
  >
    {num}
  </button>
);

const DetailPageNumberSelectorInner: React.FC<DetailPageNumberSelectorProps> = ({
  min,
  max,
  value,
  onChange,
  disabled = false,
  itemsPerRow,
}) => {
  const numbers = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  if (itemsPerRow) {
    const rows: number[][] = [];
    for (let i = 0; i < numbers.length; i += itemsPerRow) {
      rows.push(numbers.slice(i, i + itemsPerRow));
    }

    return (
      <div className={`flex flex-col gap-4 ${disabled ? 'opacity-40 pointer-events-none' : ''}`}>
        {rows.map((row, rowIdx) => (
          <div key={rowIdx} className="flex gap-4">
            {row.map((num) => (
              <NumberButton
                key={num}
                num={num}
                selected={value === num}
                disabled={disabled}
                onClick={() => onChange(num)}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex flex-wrap gap-4 ${disabled ? 'opacity-40 pointer-events-none' : ''}`}>
      {numbers.map((num) => (
        <NumberButton
          key={num}
          num={num}
          selected={value === num}
          disabled={disabled}
          onClick={() => onChange(num)}
        />
      ))}
    </div>
  );
};

export const DetailPageNumberSelector = memo(DetailPageNumberSelectorInner);
